export const GET_LEADS_SUCCESS = 'GET_LEADS_SUCCESS'
export const SET_FETCHING_LEADS = 'SET_FETCHING_LEADS'
export const SET_LEADS_FILTERS = 'SET_LEADS_FILTERS'
export const RESET_LEADS_FILTERS = 'RESET_LEADS_FILTERS'
